module.exports = __webpack_public_path__ + "img/caret-rotate.9778ec15.svg";